import { ApiTypes } from "types"

import { describeDelta, TrendMetric } from "pages/referralAgent/Dashboard/trendsData"

const buildCountMetric = (
  title: string,
  tooltip: string,
  helper: string,
  { current, previous, daily }: ApiTypes.Model.ReferralAgentTrendMetric,
): TrendMetric => ({
  title,
  tooltip,
  value: String(current),
  helper,
  ...describeDelta(current - previous, true, ""),
  trend: daily.map(({ value }) => value),
})

const buildInstallRate = (
  tooltip: string,
  helper: string,
  { current, previous, daily }: ApiTypes.Model.ReferralAgentTrendMetric,
): TrendMetric => ({
  title: "Install rate",
  tooltip,
  value: `${Math.round(current * 100)}%`,
  helper,
  ...describeDelta((current - previous) * 100, true, "%"),
  trend: daily.map(({ value }) => Math.round(value * 100)),
})

export const buildVendorTrendMetrics = (widget: ApiTypes.Model.VendorReferralTrends): TrendMetric[] => {
  const helper = `past ${widget.period} days`
  const inPeriod = `in the last ${widget.period} days`

  return [
    buildCountMetric("Referrals", `Number of referrals submitted ${inPeriod}`, helper, widget.referrals),
    buildCountMetric("Installed", `Number of referrals installed ${inPeriod}`, helper, widget.installed),
    buildCountMetric("In progress", `Number of referrals moved to in progress ${inPeriod}`, helper, widget.in_progress),
    buildInstallRate(`% of referrals installed ${inPeriod}`, helper, widget.install_rate),
  ]
}
